export const ResourceType_Laboratory = 'Laboratory';
export const ResourceType_Imaging = 'Imaging';
export const ResourceType_Procedures = 'Procedures';
export const ResourceType_Consultations = 'Consultations';
export const ResourceType_EKG = 'EKG';
export const ResourceTypes = [ResourceType_Laboratory, ResourceType_Imaging, ResourceType_Procedures, ResourceType_Consultations, ResourceType_EKG];
export const AdvisorIconType_Laboratory = 'Laboratory';
export const AdvisorIconType_Imaging = 'Imaging';
export const AdvisorIconType_VitalSigns = 'Vital Signs';
export const AdvisorIconType_Physician = 'Physician';
export const AdvisorIconTypes = [AdvisorIconType_Laboratory, AdvisorIconType_Imaging, AdvisorIconType_VitalSigns, AdvisorIconType_Physician];
//# sourceMappingURL=types.js.map